import React, { useEffect, useState } from 'react';
import TextBankCard from '../accordian-card/text-bank-card';
import { PanelName } from '../accordian-card/card-types';
import { useDispatch, useSelector } from 'react-redux';
import { getCPTCodesDescription } from 'src/redux/actions/copyTextBankAction';
import { Box, Grid, Stack, Typography } from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { summaryGridClass, summyDescription } from '../accordian-card/css-classes';

function CopyCPTCodeDescription() {
  const [expanded, setExpanded] = React.useState<PanelName>('cpt-descirption');
  const dispatch = useDispatch();

  const handleChange = (panel: PanelName) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : '');
  };

  const [search, setSearch] = useState<string | ''>('');
  const getCPTCodesDescriptionResponse = useSelector(
    (state: any) => state.getCPTCodeScriptionReducer
  );

  useEffect(() => {
    if (search.length < 3) return;
    dispatch(getCPTCodesDescription(search));
  }, [search]);

  const [getHoverId, setHoverId] = useState<string | ''>('');
  const [copiedCode, setCopiedCode] = useState<string | ''>('');

  const handleMouseIn = (code: string) => {
    setHoverId(code);
  };
  const handleMouseOut = () => {
    setHoverId('');
  };

  const handleCopyCode = (code: string, description: string) => {
    setCopiedCode(code);
    navigator.clipboard.writeText(description);
  };

  const havingData = () => {
    if (
      !getCPTCodesDescriptionResponse.response ||
      !getCPTCodesDescriptionResponse.response?.data ||
      Object.keys(getCPTCodesDescriptionResponse.response?.data).length === 0
    ) {
      return false;
    }
    return true;
  };

  const havingValidData = () => {
    if (getCPTCodesDescriptionResponse.response && getCPTCodesDescriptionResponse.response?.data) {
      return true;
    }
    return false;
  };

  const areRecordsAvailable = () => {
    if (
      search.length > 2 &&
      getCPTCodesDescriptionResponse.response?.data &&
      Object.keys(getCPTCodesDescriptionResponse.response?.data).length === 0
    ) {
      return false;
    }
    return true;
  };

  const summary = (
    <>
      {havingValidData() &&
        Object.keys(getCPTCodesDescriptionResponse.response?.data).map((code: string) => {
          return (
            <Grid
              sx={summaryGridClass}
              p={2}
              mb={2}
              onMouseOver={() => handleMouseIn(code)}
              onMouseLeave={handleMouseOut}
              onClick={() =>
                handleCopyCode(code, getCPTCodesDescriptionResponse.response?.data[code]?.long)
              }
            >
              {getHoverId === code && (
                <Box sx={summyDescription}>
                  {copiedCode === code ? (
                    <Stack>
                      <CheckBoxIcon />
                      <Typography
                        display={'inline'}
                        variant="caption"
                        sx={{ marginLeft: '-10px' }}
                      >
                        Copied !
                      </Typography>
                    </Stack>
                  ) : (
                    <ContentCopyIcon />
                  )}
                </Box>
              )}
              <Typography
                variant="body1"
                fontWeight={600}
              >
                {code} - {getCPTCodesDescriptionResponse.response?.data[code]?.short || ''}
              </Typography>
              <Typography variant="caption">
                {getCPTCodesDescriptionResponse.response?.data[code]?.long || ''}
              </Typography>
            </Grid>
          );
        })}
    </>
  );

  return (
    <TextBankCard
      expanded={expanded}
      panelName="cpt-descirption"
      handleChange={handleChange}
      title="CPT Code Description"
      requiredSearch={true}
      summary={summary}
      searchProperties={{
        searchData: search,
        setSearchData: setSearch,
        placeholder: 'Enter CPT code',
        loadingSearch: getCPTCodesDescriptionResponse.loading,
      }}
      haveData={havingData()}
      areRecordsAvailable={areRecordsAvailable}
    />
  );
}

export default CopyCPTCodeDescription;
